/**
 * Status badge variant + label for tournament lifecycle (list cards, etc.)
 */
export function getTournamentStatusVariant(status) {
  switch (status) {
    case 'draft':
      return 'default';
    case 'registration':
      return 'info';
    case 'group_stage':
      return 'warning';
    case 'knockout':
      return 'primary';
    case 'completed':
      return 'success';
    case 'cancelled':
      return 'danger';
    default:
      return 'default';
  }
}

export function getTournamentStatusLabel(status) {
  switch (status) {
    case 'draft':
      return 'Draft';
    case 'registration':
      return 'Registration';
    case 'group_stage':
      return 'Group Stage';
    case 'knockout':
      return 'Knockout';
    case 'completed':
      return 'Completed';
    case 'cancelled':
      return 'Cancelled';
    default:
      return status;
  }
}

/**
 * One-line explainer for tournament detail header (players / hosts)
 */
export function getTournamentStatusDescription(status) {
  switch (status) {
    case 'draft':
      return 'Set up rosters, then create groups and fixtures when you are ready.';
    case 'registration':
      return 'Registration is open — player list will update as people join.';
    case 'group_stage':
      return 'Group stage in progress — follow standings and match results below.';
    case 'knockout':
      return 'Knockout is running — use the bracket to see who plays next.';
    case 'completed':
      return 'This tournament has finished — results and bracket stay available to review.';
    case 'cancelled':
      return 'This tournament was cancelled — historical data may still be visible.';
    default:
      return '';
  }
}
